<div class="col-sm-12 close-button" mat-dialog-title>
  <mat-icon (click)="!isLoading && onCancel()" [class.disabled]="isLoading">close</mat-icon>
</div>
<mat-dialog-content>
  <mat-form-field appearance="fill" class="full-width">
    <mat-label>{{ 'DIALOGS.DESCRIPTION_LABEL' | translate }}</mat-label>
    <textarea
      matInput
      maxlength="20000"
      [formControl]="descriptionFormControl"
      [attr.disabled]="isLoading || null"
    ></textarea>
  </mat-form-field>
  <p class="attach-text">{{ 'DIALOGS.OR_ATTACH_FILE' | translate }}</p>
  <input #fileInput type="file" (change)="onFileSelected($event)" [disabled]="isLoading" style="display:none" />
  <button mat-stroked-button type="button" (click)="fileInput.click()" [disabled]="isLoading">
    <mat-icon>attach_file</mat-icon>
    {{ 'DIALOGS.CHOOSE_FILE' | translate }}
  </button>
  <span *ngIf="selectedFile" class="selected-file-name">{{ selectedFile.name }}</span>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button class="submit" (click)="onConfirm()" [disabled]="isLoading">
    <mat-spinner *ngIf="isLoading" diameter="18" class="button-spinner"></mat-spinner>
    <span *ngIf="!isLoading">{{ actionName === ('COMMON.BUTTONS.CANCEL' | translate) ? ('COMMON.BUTTONS.CONFIRM' | translate) :  ('COMMON.BUTTONS.'+actionName.toUpperCase()| translate) }}</span>
  </button>
  <button mat-raised-button class="discard-changes" (click)="onCancel()" [disabled]="isLoading">
    {{ 'COMMON.BUTTONS.CANCEL' | translate }}
  </button>
</mat-dialog-actions>
